import React from 'react';
import { StaticPageWithData } from '../components/StaticPage';
import PageMeta from '../components/PageMeta';

/**
 * Página de Ayuda y Soporte
 * 
 * Esta página consume datos dinámicos de la API backend a través del componente
 * StaticPageWithData, garantizando contenido siempre actualizado.
 * 
 * Funcionalidades incluidas:
 * - Carga dinámica de contenido vía API
 * - Manejo de errores robusto con opción de reintentar
 * - Estados de carga visual
 * - SEO optimizado con meta tags dinámicas
 * - Breadcrumbs para navegación
 * - Diseño responsivo
 * - Accesibilidad (ARIA labels)
 */
const HelpSupport: React.FC = () => {
  return (
    <div className="help-support-page">
      <PageMeta
        title="Ayuda y Soporte - Café Tutoriales"
        description="¿Necesitas ayuda? Encuentra soporte técnico, tutoriales y respuestas a tus dudas en la plataforma Café Tutoriales."
        keywords="ayuda, soporte, tutorial, dudas, FAQ, asistencia, cafe"
        canonical="https://cafetutoriales.com/ayuda-soporte"
      />
      <StaticPageWithData
        pageType="help"
      />
    </div>
  );
};

export default HelpSupport;